import axios from "axios";
import React, { useState, useEffect } from "react";
import moment from "moment";
import { Button } from "reactstrap";
import { baseurl } from "../../../../baseurl";
import "../../../../stickyHeaderReport.css";
import { companyCurrencyNote } from "../../../../utils/messages";
// import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import ExportToExcel from "../../SExport/ExportToExcle";
import ReportsCriteria from "../../ShortCutComponents/ReportsCriteria";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import { check_Bussiness_Permission } from "../../../../Helper";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "./formsTableSaleDetail.css";
import "./baseForms.css";
import { generateCriteriaString } from "./../../ShortFunction/shortFunctions";
import swal from "sweetalert";
import Decimal from "../../ShortCutComponents/Decimal";

let companyId = localStorage.getItem("companyId");
let username = localStorage.getItem("username");
var token = localStorage.getItem("token");

export default function SaleDetail(props) {
  const [loadingResponce, setLoadingResponce] = useState(false);
  const [data, setData] = useState({
    fromDate: "",
    toDate: "",
    customer: "",
    clientLov: "",
    customer_id: "",
    customerName: "",
    customerEmail: "",
    invoiceType: "",
    criteriaString: "All",

    checkboxBtnInvoice: "",
    checkboxBtnDraft: "",
    collapseCriteria: true,
  });
  const listOfColKey = [
    { align: "left", value: "INVOICE_DATE" },
    { align: "left", value: "DOC_NO" },
    { align: "left", value: "COMPANY_NAME" },
    { align: "left", value: "order_type_desc" },
    { align: "left", value: "ITEM_CODE" },
    { align: "left", value: "ITEM_DESC" },
    { align: "left", value: "qty" },
    { align: "left", value: "rate" },
    { align: "left", value: "AMOUNT_EXC" },
    { align: "right", value: "DISC_AMT" },
    { align: "left", value: "STAX_AMOUNT" },
    { align: "right", value: "sub_total" },
    { align: "right", value: "dstrb_surch" },
    { align: "center", value: "net_Total" },
  ];
  const listOfColLables = [
    { align: "center", value: "Invoice Date" },
    { align: "center", value: "Doc #" },
    { align: "center", value: "Customer" },
    { align: "center", value: "Order Type" },
    { align: "center", value: "Code" },
    { align: "center", value: "Item" },
    { align: "center", value: "Qty" },
    { align: "center", value: "Rate" },
    { align: "center", value: "Total" },
    { align: "center", value: "Discount" },
    { align: "center", value: "Sale Tax" },
    { align: "center", value: "Sub Total" },
    { align: "center", value: "Surcharge" },
    { align: "center", value: "Net Total" },
  ];
  const listOfColKeyDollar = [
    { align: "left", value: "INVOICE_DATE" },
    { align: "left", value: "DOC_NO" },
    { align: "left", value: "COMPANY_NAME" },
    { align: "left", value: "order_type_desc" },
    { align: "left", value: "ITEM_DESC" },
    { align: "left", value: "qty" },
    { align: "left", value: "rate" },
    { align: "left", value: "AMOUNT_EXC" },
    { align: "right", value: "DISC_AMT" },
    { align: "right", value: "STAX_AMOUNT" },
    { align: "right", value: "sub_total" },
    { align: "right", value: "dstrb_surch" },
    { align: "right", value: "net_Total" },
    { align: "right", value: "time" },
  ];
  const listOfColLablesDollar = [
    { align: "center", value: "Invoice Date" },
    { align: "center", value: "Doc #" },
    { align: "center", value: "Customer" },
    { align: "center", value: "Order Type" },
    { align: "center", value: "Item" },
    { align: "center", value: "Qty" },
    { align: "center", value: "Rate" },
    { align: "center", value: "Total" },
    { align: "center", value: "Discount" },
    { align: "center", value: "Sale Tax" },
    { align: "center", value: "Sub Total" },
    { align: "center", value: "Surcharge" },
    { align: "center", value: "Net Total" },
    { align: "center", value: "In Time" },
  ];

  const listOfColKeyEggSpectation = [
    { align: "left", value: "INVOICE_DATE" },
    { align: "left", value: "DOC_NO" },
    { align: "left", value: "COMPANY_NAME" },
    { align: "left", value: "order_type_desc" },
    { align: "left", value: "ITEM_DESC" },
    { align: "right", value: "qty" },
    { align: "left", value: "rate" },
    { align: "right", value: "AMOUNT_EXC" },
    { align: "right", value: "DISC_AMT" },
    { align: "right", value: "STAX_AMOUNT" },
    { align: "right", value: "sub_total" },
    { align: "right", value: "dstrb_surch" },
    { align: "right", value: "net_Total" },
    { align: "center", value: "waiter" },
  ];
  const listOfColLablesEggSpectation = [
    { align: "center", value: "Invoice Date" },
    { align: "center", value: "Doc #" },
    { align: "center", value: "Customer" },
    { align: "center", value: "Order Type" },
    { align: "center", value: "Item" },
    { align: "center", value: "Qty" },
    { align: "center", value: "Rate" },
    { align: "center", value: "Total" },
    { align: "center", value: "Discount" },
    { align: "center", value: "Sale Tax" },
    { align: "center", value: "Sub Total" },
    { align: "center", value: "Surcharge" },
    { align: "center", value: "Net Total" },
    { align: "center", value: "Waiter" },
  ];

  const [table, setTable] = useState({
    OverViewDataTable: [],
    filteredData: [],
  });
  const [filteredData, setFilteredData] = useState([]);
  const [dollarTrue, setdollarTrue] = useState(false);
  const [eggSpectaionTrue, setEggSpectationTrue] = useState(false);

  const [Item, setItem] = useState({
    itemLov: "",
    item_id: "",
    itemName: "",
  });

  const [showAsInteger, setShowAsInteger] = useState(false);
  const due_Formators = (cell, row, enumObject, index) => {
    let newCell = "";
    newCell = cell;
    if (typeof cell === "string") {
      newCell = parseFloat(cell.replace(/,/g, ""));
    }

    if (newCell) {
      newCell = newCell?.toLocaleString("en-US", {
        maximumFractionDigits: showAsInteger ? 0 : 2,
        minimumFractionDigits: showAsInteger ? 0 : 2,
      });

      // newCell = companySymbolCurrency + " " + newCell;
    } else {
      newCell = "0";
    }
    return newCell;
  };

  const rowClassNameFormat = (row, rowIndex) => {
    // console.log("row", row);
    const rowNo = row?.row_num == 0 ? 0 : row?.row_num;
    const currentInvoiceId = row?.master_invoice_id; // assuming master_invoice_id is the field name
    // Logic to assign the CSS class based on invoice grouping
    // console.log("row?.master_invoice_id", row?.master_invoice_id);
    // console.log(
    //   "table.OverViewDataTable[rowNo - 1]?.master_invoice_id",
    //   table.OverViewDataTable[rowNo - 1]?.master_invoice_id
    // );
    return rowIndex === 0 ||
      row?.master_invoice_id !==
        table.OverViewDataTable[rowNo - 1]?.master_invoice_id
      ? "master-invoice-border-No-Bottom"
      : row?.master_invoice_id ==
        table.OverViewDataTable[rowNo - 1]?.master_invoice_id
      ? "master-invoice-border-Side"
      : "master-invoice-border-No-Top";
  };
  useEffect(() => {
    checkBussinessPermission();

    // getAccountsSummary();
  }, []);

  const checkBussinessPermission = async () => {
    let checkBussinessPermission = await check_Bussiness_Permission();
    console.log("checkBussinessPermission :>> ", checkBussinessPermission[0]);
    let {
      business_type_id,
      isCrumble,
      isAgh,
      isDollarjnction,
      isEggSpectation,
    } = checkBussinessPermission;
    if (isDollarjnction) {
      setdollarTrue(true);
      setShowAsInteger(true);
    }
    if (isEggSpectation) {
      setEggSpectationTrue(true);
    }
  };

  const getAccountsSummary = (
    startDate,
    endDate,
    item_id,
    multiItemLabel,
    multiOrderTypeLabel,
    orderType_id,
    multiPosBranchLabel,
    multiPosBranch,
    branch_id,
    saleChannel_id,
    multiSaleChannelLabel
  ) => {
    // 1st call for Load data in Data table. We are on the main page.
    // let isLoadedName = this.props.location.state?.idFromClientOverview;

    let sDate = startDate ? moment(startDate).format("YYYY-MM-DD") : null;
    let eDate = endDate ? moment(endDate).format("YYYY-MM-DD") : null;
    setLoadingResponce(true);
    let sysDate = new Date();

    // return
    axios
      .post(
        `${baseurl}/repots/getResSaleDetailsReport`,
        {
          companyId: companyId,
          fromDate: sDate,
          toDate: eDate,
          Item: item_id,
          orderType: orderType_id, // orderType_id?.multiOrderType,
          saleChannel_id: saleChannel_id, //payMode_id?.multiPayMode,
          multiPosBranch: multiPosBranch || branch_id?.id || branch_id, //multiPosBranch_id?.id || branch_id?.id || branch_id,
          username: username,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )

      .then(function (response) {
        let callData = response.data.data;
        let todayDate = new Date();
        if (callData.length > 0) {
          todayDate = moment(todayDate).format("YYYY-MM-DD");

          let totalSumAll = {
            sumqty: 0,
            sumTotal: 0,
            sumDiscount: 0,
            sumSaleTaAmt: 0,
            sumSubTotal: 0,
            sumSurcharge: 0,
            sumNetTotal: 0,
            // due: 0,
          };
          let objEmpty = {
            sr_no: "",
            INVOICE_DATE: "",
            DOC_NO: "",
            row_num: "",
            COMPANY_NAME: "",
            order_type_desc: "",
            ITEM_CODE: "",
            ITEM_DESC: "",
            qty: "",
            rate: "",
            AMOUNT_EXC: "",
            DISC_AMT: "",
            STAX_AMOUNT: "",
            sub_total: "",
            dstrb_surch: "",
            net_Total: "",
          };
          let objEmptyDollar = {
            sr_no: "",
            INVOICE_DATE: "",
            DOC_NO: "",
            row_num: "",
            COMPANY_NAME: "",
            order_type_desc: "",
            ITEM_DESC: "",
            qty: "",
            rate: "",
            AMOUNT_EXC: "",
            DISC_AMT: "",
            STAX_AMOUNT: "",
            sub_total: "",
            dstrb_surch: "",
            net_Total: "",
            time: "",
          };
          let objEmptyEggSpectation = {
            sr_no: "",
            INVOICE_DATE: "",
            DOC_NO: "",
            row_num: "",
            COMPANY_NAME: "",
            order_type_desc: "",
            ITEM_DESC: "",
            qty: "",
            rate: "",
            AMOUNT_EXC: "",
            DISC_AMT: "",
            STAX_AMOUNT: "",
            sub_total: "",
            dstrb_surch: "",
            net_Total: "",
            waiter: "",
          };
          let newArr = [
            {
              // sr_no: "Sale Detail Report",
              INVOICE_DATE: "Sale Detail Report",
              DOC_NO: "",
              // row_num: "",

              COMPANY_NAME: "",
              order_type_desc: "",
              ITEM_CODE: "",
              ITEM_DESC: "",
              qty: "",
              rate: "",
              AMOUNT_EXC: "",
              DISC_AMT: companyCurrencyNote,
              STAX_AMOUNT: "",
              sub_total: "",
              dstrb_surch: "",
              net_Total: "",
            },
            objEmpty,
            {
              sr_no: "sr_no",
              INVOICE_DATE: "Date",
              DOC_NO: "No",
              row_num: "rowNo",
              COMPANY_NAME: "Customer",
              order_type_desc: "Order Type",
              ITEM_CODE: "Item Code",
              ITEM_DESC: "Item",
              qty: "Qty",
              rate: "Rate",
              AMOUNT_EXC: "Total",
              DISC_AMT: "Discount",
              STAX_AMOUNT: "Sale Tax",
              sub_total: "Sub Total",
              dstrb_surch: "Surcharge",
              net_Total: "Net Total",
            },
          ];
          let newArrDollar = [
            {
              sr_no: "Sale Detail Report",
              INVOICE_DATE: "",
              DOC_NO: "",
              row_num: "",

              COMPANY_NAME: "",
              order_type_desc: "",
              ITEM_DESC: "",
              qty: "",
              rate: "",
              AMOUNT_EXC: "",
              DISC_AMT: companyCurrencyNote,
              STAX_AMOUNT: "",
              sub_total: "",
              dstrb_surch: "",
              net_Total: "",
              time: "",
            },
            objEmpty,
            {
              sr_no: "sr_no",
              INVOICE_DATE: "Date",
              DOC_NO: "No",
              row_num: "rowNo",
              COMPANY_NAME: "Customer",
              order_type_desc: "Order Type",
              ITEM_DESC: "Item",
              qty: "Qty",
              rate: "Rate",
              AMOUNT_EXC: "Total",
              DISC_AMT: "Discount",
              STAX_AMOUNT: "Sale Tax",
              sub_total: "Sub Total",
              dstrb_surch: "Surcharge",
              net_Total: "Net Total",
              time: "time",
            },
          ];
          let newArrEggSpectation = [
            {
              sr_no: "Sale Detail Report",
              INVOICE_DATE: "",
              DOC_NO: "",
              row_num: "",

              COMPANY_NAME: "",
              order_type_desc: "",
              ITEM_DESC: "",
              qty: "",
              rate: "",
              AMOUNT_EXC: "",
              DISC_AMT: companyCurrencyNote,
              STAX_AMOUNT: "",
              sub_total: "",
              dstrb_surch: "",
              net_Total: "",
              waiter: "",
            },
            objEmpty,
            {
              sr_no: "sr_no",
              INVOICE_DATE: "Date",
              DOC_NO: "No",
              row_num: "rowNo",
              COMPANY_NAME: "Customer",
              order_type_desc: "Order Type",
              ITEM_DESC: "Adjusted Amount",
              qty: "Item",
              rate: "Quantity",
              AMOUNT_EXC: "Rate",
              DISC_AMT: "Value Exclusive Amount",
              STAX_AMOUNT: "Discount",
              sub_total: "Sub Total",
              dstrb_surch: "Sale Tax Amount",
              net_Total: "Value Inclusive Amount",
              // waiter: "waiter",
            },
          ];
          let sumqty = 0;
          let sumTotal = 0;
          let sumDiscount = 0;
          let sumSaleTaAmt = 0;
          let sumSubTotal = 0;
          let sumSurcharge = 0;
          let sumNetTotal = 0;
          let printData = [];
          let printDataDollar = [];
          let printDataEggSpectation = [];

          for (let index = 0; index < callData.length; index++) {
            let element = callData[index];
            let netTotalIndexWise = 0;
            // console.log("element.sub_total", element.sub_total);
            // console.log("element.dstrb_surch", element.dstrb_surch);
            netTotalIndexWise =
              Number(element.sub_total) + Number(element.dstrb_surch);
            // The query returns a per-invoice "Sub Total" row alongside that
            // invoice's detail lines, holding the SUM() of those same lines.
            // It must stay out of the grand totals or every invoice is counted
            // twice - it is still pushed as a row further down.
            const isSubTotalRow = element["ITEM_DESC"] === "Sub Total";
            if (!isSubTotalRow) {
              sumqty = sumqty + Number(element?.qty);
              sumTotal = sumTotal + Number(element?.AMOUNT_EXC);
              sumDiscount = sumDiscount + Number(element?.DISC_AMT);
              sumSaleTaAmt = sumSaleTaAmt + Number(element?.STAX_AMOUNT);
              sumSubTotal = sumSubTotal + Number(element?.sub_total);
              sumSurcharge = sumSurcharge + Number(element?.dstrb_surch);
              sumNetTotal = sumNetTotal + Number(netTotalIndexWise);
              totalSumAll = {
                sumqty: totalSumAll.sumqty + Number(element?.qty),
                sumTotal: totalSumAll.sumTotal + Number(element?.AMOUNT_EXC),
                sumDiscount:
                  totalSumAll.sumDiscount + Number(element?.DISC_AMT),
                sumSaleTaAmt:
                  totalSumAll.sumSaleTaAmt + Number(element?.STAX_AMOUNT),
                sumSubTotal:
                  totalSumAll.sumSubTotal + Number(element?.sub_total),
                sumSurcharge:
                  totalSumAll.sumSurcharge + Number(element?.dstrb_surch),
                sumNetTotal: totalSumAll.sumNetTotal + Number(netTotalIndexWise),
              };
            }
            newArr.push({
              // sr_no: index + 1,
              // master_invoice_id: element["master_invoice_id"],
              INVOICE_DATE: element["INVOICE_DATE"] ? element["INVOICE_DATE"]+ "  " + element["time"]: "",
              DOC_NO: element["DOC_NO"],
              // row_num: element["row_num"],
              // row_num:
              //   username === "test2_res@gmail.com"
              //     ? element["row_num"] === 1
              //       ? 0
              //       : element["row_num"] === 0
              //       ? 1
              //       : element["row_num"]
              //     : element["row_num"],
              COMPANY_NAME: element["COMPANY_NAME"],
              order_type_desc: element["order_type_desc"],
              ITEM_CODE: element["ITEM_CODE"],
              ITEM_DESC: element["ITEM_DESC"],
              qty: Number(element["qty"]),
              rate: Number(element["rate"]),
              AMOUNT_EXC: Number(element["AMOUNT_EXC"]),
              DISC_AMT: Number(element["DISC_AMT"]),
              STAX_AMOUNT: Number(element["STAX_AMOUNT"]),
              sub_total: Number(element["sub_total"]),
              dstrb_surch: Number(element["dstrb_surch"]),
              net_Total: netTotalIndexWise,
              // time: element["time"],
              // waiter: element["waiter"],
            });
            newArrDollar.push({
              sr_no: index + 1,
              master_invoice_id: element["master_invoice_id"],
              INVOICE_DATE: element["INVOICE_DATE"],
              DOC_NO: element["DOC_NO"],
              row_num: element["row_num"],
              // row_num:
              //   username === "test2_res@gmail.com"
              //     ? element["row_num"] === 1
              //       ? 0
              //       : element["row_num"] === 0
              //       ? 1
              //       : element["row_num"]
              //     : element["row_num"],
              COMPANY_NAME: element["COMPANY_NAME"],
              order_type_desc: element["order_type_desc"],
              ITEM_DESC: element["ITEM_DESC"],
              qty: Number(element["qty"]),
              rate: Number(element["rate"]),
              AMOUNT_EXC: Number(element["AMOUNT_EXC"]),
              DISC_AMT: Number(element["DISC_AMT"]),
              STAX_AMOUNT: Number(element["STAX_AMOUNT"]),
              sub_total: Number(element["sub_total"]),
              dstrb_surch: Number(element["dstrb_surch"]),
              net_Total: Number(netTotalIndexWise),
              time: element["time"],
            });
            newArrEggSpectation.push({
              sr_no: index + 1,
              master_invoice_id: element["master_invoice_id"],
              INVOICE_DATE: element["INVOICE_DATE"] ? element["INVOICE_DATE"]+ "  " + element["time"]: "",
              DOC_NO: element["DOC_NO"],
              row_num: element["row_num"],
              // row_num:
              //   username === "test2_res@gmail.com"
              //     ? element["row_num"] === 1
              //       ? 0
              //       : element["row_num"] === 0
              //       ? 1
              //       : element["row_num"]
              //     : element["row_num"],
              COMPANY_NAME: element["COMPANY_NAME"],
              order_type_desc: element["order_type_desc"],
              ITEM_DESC: element["ITEM_CODE"] ? element["ITEM_CODE"] + "  " + element["ITEM_DESC"]:"",
              qty: Number(element["qty"]),
              rate: Number(element["rate"]),
              AMOUNT_EXC: Number(element["AMOUNT_EXC"]),
              DISC_AMT: Number(element["DISC_AMT"]),
              STAX_AMOUNT: Number(element["STAX_AMOUNT"]),
              sub_total: Number(element["sub_total"]),
              dstrb_surch: Number(element["dstrb_surch"]),
              net_Total: netTotalIndexWise,
              waiter: element["waiter"],
            });
            if (username === "test2_res@gmail.com") {
              if (element["row_num"] === 0) {
                printData.unshift({
                  sr_no: index + 1,
                  master_invoice_id: element["master_invoice_id"],
                  INVOICE_DATE: element["INVOICE_DATE"],
                  DOC_NO: element["DOC_NO"],
                  row_num: element["row_num"],
                  COMPANY_NAME: element["COMPANY_NAME"],
                  order_type_desc: element["order_type_desc"],
                  ITEM_DESC: element["ITEM_DESC"],
                  qty: due_Formators(element["qty"]),
                  rate: due_Formators(element["rate"]),
                  AMOUNT_EXC: due_Formators(element["AMOUNT_EXC"]),
                  DISC_AMT: due_Formators(element["DISC_AMT"]),
                  STAX_AMOUNT: due_Formators(element["STAX_AMOUNT"]),
                  sub_total: due_Formators(element["sub_total"]),
                  dstrb_surch: due_Formators(element["dstrb_surch"]),
                  net_Total: due_Formators(netTotalIndexWise),
                  time: element["time"],
                  waiter: element["waiter"],
                });
                printDataDollar.unshift({
                  sr_no: index + 1,
                  master_invoice_id: element["master_invoice_id"],
                  INVOICE_DATE: element["INVOICE_DATE"],
                  DOC_NO: element["DOC_NO"],
                  row_num: element["row_num"],
                  COMPANY_NAME: element["COMPANY_NAME"],
                  order_type_desc: element["order_type_desc"],
                  ITEM_DESC: element["ITEM_DESC"],
                  qty: due_Formators(element["qty"]),
                  rate: due_Formators(element["rate"]),
                  AMOUNT_EXC: due_Formators(element["AMOUNT_EXC"]),
                  DISC_AMT: due_Formators(element["DISC_AMT"]),
                  STAX_AMOUNT: due_Formators(element["STAX_AMOUNT"]),
                  sub_total: due_Formators(element["sub_total"]),
                  dstrb_surch: due_Formators(element["dstrb_surch"]),
                  net_Total: due_Formators(netTotalIndexWise),
                  time: element["time"],
                });
                printDataEggSpectation.unshift({
                  // sr_no: index + 1,
                  // master_invoice_id: element["master_invoice_id"],
                  INVOICE_DATE: element["INVOICE_DATE"],
                  DOC_NO: element["DOC_NO"],
                  // row_num: element["row_num"],
                  COMPANY_NAME: element["COMPANY_NAME"],
                  order_type_desc: element["order_type_desc"],
                  ITEM_DESC: element["ITEM_DESC"],
                  qty: due_Formators(element["qty"]),
                  rate: due_Formators(element["rate"]),
                  AMOUNT_EXC: due_Formators(element["AMOUNT_EXC"]),
                  DISC_AMT: due_Formators(element["DISC_AMT"]),
                  STAX_AMOUNT: due_Formators(element["STAX_AMOUNT"]),
                  sub_total: due_Formators(element["sub_total"]),
                  dstrb_surch: due_Formators(element["dstrb_surch"]),
                  net_Total: due_Formators(netTotalIndexWise),
                  waiter: element["waiter"],
                });
              } else {
                printData.push({
                  sr_no: index + 1,
                  master_invoice_id: element["master_invoice_id"],
                  INVOICE_DATE: element["INVOICE_DATE"]+ "  " + element["time"],
                  DOC_NO: element["DOC_NO"],
                  row_num: element["row_num"],
                  COMPANY_NAME: element["COMPANY_NAME"],
                  order_type_desc: element["order_type_desc"],
                  ITEM_CODE: element["ITEM_CODE"],
                  ITEM_DESC: element["ITEM_DESC"],
                  qty: due_Formators(Number(element["qty"])),
                  rate: due_Formators(Number(element["rate"])),
                  AMOUNT_EXC: due_Formators(Number(element["AMOUNT_EXC"])),
                  DISC_AMT: due_Formators(Number(element["DISC_AMT"])),
                  STAX_AMOUNT: due_Formators(Number(element["STAX_AMOUNT"])),
                  sub_total: due_Formators(Number(element["sub_total"])),
                  dstrb_surch: due_Formators(Number(element["dstrb_surch"])),
                  net_Total: Number(netTotalIndexWise),
                  // time: element["time"],
                  // waiter: element["waiter"],
                });
                printDataDollar.push({
                  sr_no: index + 1,
                  master_invoice_id: element["master_invoice_id"],
                  INVOICE_DATE: element["INVOICE_DATE"],
                  DOC_NO: element["DOC_NO"],
                  row_num: element["row_num"],
                  COMPANY_NAME: element["COMPANY_NAME"],
                  order_type_desc: element["order_type_desc"],
                  ITEM_DESC: element["ITEM_DESC"],
                  qty: due_Formators(Number(element["qty"])),
                  rate: due_Formators(Number(element["rate"])),
                  AMOUNT_EXC: due_Formators(Number(element["AMOUNT_EXC"])),
                  DISC_AMT: due_Formators(Number(element["DISC_AMT"])),
                  STAX_AMOUNT: due_Formators(Number(element["STAX_AMOUNT"])),
                  sub_total: due_Formators(Number(element["sub_total"])),
                  dstrb_surch: due_Formators(Number(element["dstrb_surch"])),
                  net_Total: due_Formators(Number(netTotalIndexWise)),
                  time: element["time"],
                });
                printDataEggSpectation.push({
                  // sr_no: index + 1,
                  // master_invoice_id: element["master_invoice_id"],
                 INVOICE_DATE: element["INVOICE_DATE"]+ "  " + element["time"],
                  DOC_NO: element["DOC_NO"],
                  // row_num: element["row_num"],
                  COMPANY_NAME: element["COMPANY_NAME"],
                  order_type_desc: element["order_type_desc"],
                 ITEM_DESC: element["ITEM_CODE"] + "  " + element["ITEM_DESC"],
                  qty: due_Formators(Number(element["qty"])),
                  rate: due_Formators(Number(element["rate"])),
                  AMOUNT_EXC: due_Formators(Number(element["AMOUNT_EXC"])),
                  DISC_AMT: due_Formators(Number(element["DISC_AMT"])),
                  STAX_AMOUNT: due_Formators(Number(element["STAX_AMOUNT"])),
                  sub_total: due_Formators(Number(element["sub_total"])),
                  dstrb_surch: due_Formators(Number(element["dstrb_surch"])),
                  net_Total: Number(netTotalIndexWise),
                  waiter: element["waiter"],
                });
              }
            } else {
              printData.push({
                sr_no: index + 1,
                master_invoice_id: element["master_invoice_id"],
                 INVOICE_DATE: element["INVOICE_DATE"] ? element["INVOICE_DATE"]+ "  " + element["time"] : "",
                DOC_NO: element["DOC_NO"],
                row_num: element["row_num"],
                COMPANY_NAME: element["COMPANY_NAME"],
                order_type_desc: element["order_type_desc"],
                ITEM_CODE: element["ITEM_CODE"],
                ITEM_DESC: element["ITEM_DESC"],

                qty: due_Formators(Number(element["qty"])),
                rate: due_Formators(Number(element["rate"])),
                AMOUNT_EXC: due_Formators(Number(element["AMOUNT_EXC"])),
                DISC_AMT: due_Formators(Number(element["DISC_AMT"])),
                STAX_AMOUNT: due_Formators(Number(element["STAX_AMOUNT"])),
                sub_total: due_Formators(Number(element["sub_total"])),
                dstrb_surch: due_Formators(Number(element["dstrb_surch"])),
                net_Total: due_Formators(Number(netTotalIndexWise)),
                // time: element["time"],
                // waiter: element["waiter"],
              });
              printDataDollar.push({
                sr_no: index + 1,
                master_invoice_id: element["master_invoice_id"],
                INVOICE_DATE: element["INVOICE_DATE"],
                DOC_NO: element["DOC_NO"],
                row_num: element["row_num"],
                COMPANY_NAME: element["COMPANY_NAME"],
                order_type_desc: element["order_type_desc"],
                ITEM_DESC: element["ITEM_DESC"],
                qty: due_Formators(Number(element["qty"])),
                rate: due_Formators(Number(element["rate"])),
                AMOUNT_EXC: due_Formators(Number(element["AMOUNT_EXC"])),
                DISC_AMT: due_Formators(Number(element["DISC_AMT"])),
                STAX_AMOUNT: due_Formators(Number(element["STAX_AMOUNT"])),
                sub_total: due_Formators(Number(element["sub_total"])),
                dstrb_surch: due_Formators(Number(element["dstrb_surch"])),
                net_Total: due_Formators(Number(netTotalIndexWise)),
                time: element["time"],
              });
              printDataEggSpectation.push({
                // sr_no: index + 1,
                // master_invoice_id: element["master_invoice_id"],
                INVOICE_DATE: element["INVOICE_DATE"] ? element["INVOICE_DATE"]+ "  " + element["time"] : "",
                DOC_NO: element["DOC_NO"],
                // row_num: element["row_num"],
                COMPANY_NAME: element["COMPANY_NAME"],
                order_type_desc: element["order_type_desc"],
                ITEM_DESC: element["ITEM_CODE"] ? element["ITEM_CODE"] + "  " + element["ITEM_DESC"] : "",
                qty: due_Formators(Number(element["qty"])),
                rate: due_Formators(Number(element["rate"])),
                AMOUNT_EXC: due_Formators(Number(element["AMOUNT_EXC"])),
                DISC_AMT: due_Formators(Number(element["DISC_AMT"])),
                STAX_AMOUNT: due_Formators(Number(element["STAX_AMOUNT"])),
                sub_total: due_Formators(Number(element["sub_total"])),
                dstrb_surch: due_Formators(Number(element["dstrb_surch"])),
                net_Total: due_Formators(Number(netTotalIndexWise)),
                waiter: element["waiter"],
              });
                // console.log('netTotalIndexWise :>> ', netTotalIndexWise);
                // console.log('printDataEggSpectation :>> ', printDataEggSpectation);

            }
          }

          totalSumAll = Object.keys(totalSumAll).map((key, index) => [
            totalSumAll[key],
          ]);

          newArr.push(objEmpty);
          newArr.push({
            // sr_no: "Total",
            INVOICE_DATE: "Total",
            DOC_NO: "0",
            COMPANY_NAME: "0",
            order_type_desc: "0",
            ITEM_CODE: "0",
            ITEM_DESC: "0",
            qty: due_Formators(sumqty),
            rate: "",
            AMOUNT_EXC: due_Formators(sumTotal),
            DISC_AMT: due_Formators(sumDiscount),
            STAX_AMOUNT: due_Formators(sumSaleTaAmt),
            sub_total: due_Formators(sumSubTotal),
            dstrb_surch: due_Formators(sumSurcharge),
            net_Total: due_Formators(sumNetTotal),
          });
          newArrDollar.push(objEmptyDollar);
          newArrDollar.push({
            sr_no: "Total",
            INVOICE_DATE: "",
            DOC_NO: "0",
            COMPANY_NAME: "0",
            order_type_desc: "0",
            ITEM_DESC: "0",
            qty: due_Formators(sumqty),
            rate: "",
            AMOUNT_EXC: due_Formators(sumTotal),
            DISC_AMT: due_Formators(sumDiscount),
            STAX_AMOUNT: due_Formators(sumSaleTaAmt),
            sub_total: due_Formators(sumSubTotal),
            dstrb_surch: due_Formators(sumSurcharge),
            net_Total: due_Formators(sumNetTotal),
            time: "-",
          });
          newArrEggSpectation.push(objEmptyEggSpectation);
          newArrEggSpectation.push({
            INVOICE_DATE: "Total",
            DOC_NO: "0",
            COMPANY_NAME: "0",
            order_type_desc: "0",
            ITEM_DESC: "0",
            qty: due_Formators(sumqty),
            rate: "",
            AMOUNT_EXC: due_Formators(sumTotal),
            DISC_AMT: due_Formators(sumDiscount),
            STAX_AMOUNT: due_Formators(sumSaleTaAmt),
            sub_total: due_Formators(sumSubTotal),
            dstrb_surch: due_Formators(sumSurcharge),
            net_Total: due_Formators(sumNetTotal),
            waiter: "",
          });
          let mainScreenDataTable = [...printData];

          printData.push({
            INVOICE_DATE: "Total",
            DOC_NO: "-",
            COMPANY_NAME: "-",
            order_type_desc: "-",
            ITEM_CODE: "-",
            ITEM_DESC: "-",
            qty: due_Formators(sumqty),
            rate: "-",
            AMOUNT_EXC: due_Formators(sumTotal),
            DISC_AMT: due_Formators(sumDiscount),
            STAX_AMOUNT: due_Formators(sumSaleTaAmt),
            sub_total: due_Formators(sumSubTotal),
            dstrb_surch: due_Formators(sumSurcharge),
            net_Total: due_Formators(sumNetTotal),
          });
          printDataDollar.push({
            INVOICE_DATE: "Total",
            DOC_NO: "-",
            COMPANY_NAME: "-",
            order_type_desc: "-",
            ITEM_DESC: "-",
            qty: due_Formators(sumqty),
            rate: "-",
            AMOUNT_EXC: due_Formators(sumTotal),
            DISC_AMT: due_Formators(sumDiscount),
            STAX_AMOUNT: due_Formators(sumSaleTaAmt),
            sub_total: due_Formators(sumSubTotal),
            dstrb_surch: due_Formators(sumSurcharge),
            net_Total: due_Formators(sumNetTotal),
            time: "-",
          });
          printDataEggSpectation.push({
            INVOICE_DATE: "Total",
            DOC_NO: "-",
            COMPANY_NAME: "-",
            order_type_desc: "-",
            ITEM_DESC: "-",
            qty: due_Formators(sumqty),
            rate: "-",
            AMOUNT_EXC: due_Formators(sumTotal),
            DISC_AMT: due_Formators(sumDiscount),
            STAX_AMOUNT: due_Formators(sumSaleTaAmt),
            sub_total: due_Formators(sumSubTotal),
            dstrb_surch: due_Formators(sumSurcharge),
            net_Total: due_Formators(sumNetTotal),
            waiter: "",
          });
console.log('newArr :>> ', newArr);
          setTable({
            ...table,
            OverViewDataTable: mainScreenDataTable,
            totalSumAll,
            mainScreenDataTable,
            printData,
            printDataDollar,
            printDataEggSpectation,
            listOfData: newArr,
            listOfDataDollar: newArrDollar,
            listOfDataEggSpectation: newArrEggSpectation,
          });
          setFilteredData(mainScreenDataTable);
          setLoadingResponce(false);
        } else {
          setTable({
            ...table,
            OverViewDataTable: [],
            totalSumAll: [],
            mainScreenDataTable: [],
            printData: [],
            listOfData: [],
            printDataDollar: [],
            listOfDataDollar: [],
            printDataEggSpectation: [],
            listOfDataEggSpectation: [],
          });
          setLoadingResponce(false);

          setFilteredData([]);
        }
      })
      .catch(function (error) {
        setLoadingResponce(false);

        console.log(error);
      });
  };
  const onChangeRadioBtn = (e) => {
    setData({
      ...data,
      invoiceType: e.target.value,
    });
  };
  const CustomerHandleChange = (customer_id) => {
    setData({
      ...data,
      customer_id,
      customerName: customer_id?.label,
      customerEmail: customer_id?.email,
    });
  };
  const funPrintView = (data1, headers, headerKeyMap, allData) => {
    console.log('eggSpectaionTrue :>> ', eggSpectaionTrue);
    const { radioBtn, radioBtn2 } = allData;

    let fromDate = allData.fromDate
      ? moment(allData.fromDate).format("DD-MMM-YYYY")
      : "All";
    let toDate = allData.toDate
      ? moment(allData.toDate).format("DD-MMM-YYYY")
      : "All";
    let radioOption =
      radioBtn === "1"
        ? "All"
        : radioBtn === "2"
        ? "Fully Paid"
        : radioBtn === "3"
        ? "Due (Only Exclusive Fully Paid)"
        : radioBtn === "4"
        ? "Over Due"
        : "All";
    let radioOption2 =
      radioBtn2 === "1"
        ? "All"
        : radioBtn2 === "2"
        ? "Invoice Only"
        : radioBtn2 === "3"
        ? "Draft Only"
        : radioBtn2 === "4"
        ? "Estimate Only"
        : "All";

    let dateCriteria =
      fromDate === "All" && toDate === "All"
        ? {
            label: "Date",
            value: "All",
          }
        : ({
            label: "From Date",
            value: fromDate,
          },
          {
            label: "To Date",
            value: toDate,
          });
    let criteria = [
      dateCriteria,
      {
        label: "Customer",
        value: customer_id?.label ? customer_id?.label : "All",
      },
      {
        label: "Item",
        value: item_id?.label ? item_id?.label : "All",
      },
      {
        label: "Status",
        value: radioOption,
      },
      {
        label: "Invoice Type",
        value: radioOption2,
      },
    ];

    const formattedPrintData = table.printData.map((item) => ({
      INVOICE_DATE: item.INVOICE_DATE,
      DOC_NO: item.DOC_NO,
      COMPANY_NAME: item.COMPANY_NAME,
      order_type_desc: item.order_type_desc,
      ITEM_CODE: item.ITEM_CODE,
      ITEM_DESC: item.ITEM_DESC,
      qty: item.qty,
      rate: item.rate,
      AMOUNT_EXC: item.AMOUNT_EXC,
      DISC_AMT: item.DISC_AMT,
      STAX_AMOUNT: item.STAX_AMOUNT,
      sub_total: item.sub_total,
      dstrb_surch: item.dstrb_surch,
      net_Total: item.net_Total,
    }));
// console.log('table.printData :>> ', table.printData);
// console.log('formattedPrintData :>> ', formattedPrintData);
    const formattedprintDataDollar = table.printDataDollar.map((item) => ({
      INVOICE_DATE: item.INVOICE_DATE,
      DOC_NO: item.DOC_NO,
      COMPANY_NAME: item.COMPANY_NAME,
      order_type_desc: item.order_type_desc,
      ITEM_DESC: item.ITEM_DESC,
      qty: due_Formators(item.qty),
      rate: due_Formators(item.rate),
      AMOUNT_EXC: due_Formators(item.total),
      DISC_AMT: due_Formators(item.discount),
      STAX_AMOUNT: due_Formators(item.stax_amount),
      sub_total: due_Formators(item.sub_total),
      dstrb_surch: due_Formators(item.sale_surch),
      net_Total: due_Formators(item.net_total),
      time: item.time,
    }));

    const formattedprintDataEggSpectation = table.printDataEggSpectation.map(
      (item) => ({
        INVOICE_DATE: item.INVOICE_DATE,
        DOC_NO: item.DOC_NO,
        COMPANY_NAME: item.COMPANY_NAME,
        order_type_desc: item.order_type_desc,
        ITEM_DESC: item.ITEM_DESC,
        qty: due_Formators(item.qty),
        rate: due_Formators(item.rate),
        AMOUNT_EXC: due_Formators(item.AMOUNT_EXC),
        DISC_AMT: due_Formators(item.DISC_AMT),
        STAX_AMOUNT: due_Formators(item.STAX_AMOUNT),
        sub_total: due_Formators(item.sub_total),
        dstrb_surch: due_Formators(item.sale_surch),
        net_Total: due_Formators(item.net_Total),
        waiter: item.waiter,
      })
    );

    props.history.push({
      pathname: "/PrintReports",
      state: {
        data: dollarTrue
          ? formattedprintDataDollar
          : eggSpectaionTrue
          ? formattedprintDataEggSpectation
          : formattedPrintData,
        headers: headers,
        headerKeyMap: headerKeyMap,
        goBackUrl: "/Res_SaleDetailReport",
        dynamicInvMessage: "Sale Detail Report",
        reportName: "Sale_Detail_Report",
        criteria,
        criteriaString: data.criteriaString,
      },
    });
  };
  const graph = () => {
    swal({
      title: "Coming Soon",
      text: "This feature is under development",
      icon: "warning",
      timer: 2000,
      buttons: false,
    });
  };
  const itemHandleChange = (item_id) => {
    setItem({
      ...Item,
      item_id,
      itemName: item_id?.label,
    });
  };
  const indexN = (cell, row, enumObject, index) => {
    return <div>{index + 1}</div>;
  };
  const handleDynamicColapse = (p) => {
    console.log("p", p);
    const { collapseCriteria } = p;
    setData({
      ...data,
      collapseCriteria,
    });
  };
  const sendSearchedData = (p) => {
    console.log("p", p);
    const { filteredData } = p;
    setFilteredData(filteredData);
  };
  const handleFind = (p) => {
    const {
      fromDate,
      toDate,
      item_id,
      multiItemLabel,
      multiOrderTypeLabel,
      orderType_id,
      multiPosBranchLabel,
      multiPosBranch,
      branch_id,
      saleChannel_id,
      multiSaleChannelLabel,
    } = p;
    const critObj = {
      fromDate,
      toDate,
      item_id,
      multiItemLabel: multiItemLabel || item_id?.label,
      multiOrderTypeLabel: multiOrderTypeLabel || orderType_id?.label,
      orderType_id,
      multiPosBranchLabel: multiPosBranchLabel || branch_id?.label,
      multiPosBranch: multiPosBranch || branch_id,
      branch_id,
      saleChannel_id,
      multiSaleChannelLabel: multiSaleChannelLabel || saleChannel_id?.label,
    };
    const criteriaString = generateCriteriaString(critObj);
    setData({
      criteriaString: criteriaString,
    });
    console.log("criteriaString :>> ", criteriaString);
let BranchCheck = multiPosBranch || branch_id;
        if (!BranchCheck) {
          swal({
            title: "Branch Not Selected",
            text: "Please select branch",
            icon: "warning",
          });
          return;
        }
    getAccountsSummary(
      fromDate,
      toDate,
      item_id,
      multiItemLabel,
      multiOrderTypeLabel,
      orderType_id,
      multiPosBranchLabel,
      multiPosBranch,
      branch_id,
      saleChannel_id,
      multiSaleChannelLabel
    );
  };

  const options = {
    paginationShowsTotal: true,
    page: 1,
    sizePerPage: 15,
    pageStartIndex: 1,
    paginationSize: 5,
    prePage: "Prev",
    nextPage: "Next",
    firstPage: "First",
    lastPage: "Last",
    prePageTitle: "Go to previous",
    nextPageTitle: "Go to next",
    firstPageTitle: "Go to first",
    lastPageTitle: "Go to last",
    sizePerPageList: [
      { text: "10", value: 10 },
      { text: "30", value: 30 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "All", value: filteredData?.length || 100 }, // fallback
    ],
    custom: true,
  };
  // State to track whether COMPANY_NAME column is expanded (visible) or collapsed (hidden)
  const [isCompanyNameVisible, setCompanyNameVisible] = useState(true);
  const [isPrintVisible, setisPrintVisible] = useState(false);
// make it true true isPrintVisible
  // Toggle function to show/hide the COMPANY_NAME column
  const toggleCompanyName = () => {
    setCompanyNameVisible(!isCompanyNameVisible);
  };
  const { fromDate, toDate, customer_id, clientLov } = data;
  const { itemLov, itemName, item_id } = Item;
  // const totalqty = filteredData.reduce(
  //   (acc, item) => acc + parseFloat(item.qty.replace(/,/g, "")),
  //   0
  // );
  const totalqty = filteredData.reduce((acc, item) => {
    if (item.qty !== "-" && item.qty !== "" && item.ITEM_DESC == "Sub Total") {
      return acc + parseFloat(item.qty.replace(/,/g, ""));
    }
    return acc;
  }, 0);
  // const totalAMOUNT_EXC = filteredData.reduce(
  //   (acc, item) => acc + parseFloat(item.AMOUNT_EXC.replace(/,/g, "")),
  //   0
  // );
  const totalAMOUNT_EXC = filteredData.reduce((acc, item) => {
    if (
      item.AMOUNT_EXC !== "-" &&
      item.AMOUNT_EXC !== "" &&
      item.ITEM_DESC == "Sub Total"
    ) {
      return acc + parseFloat(item.AMOUNT_EXC.replace(/,/g, ""));
    }
    return acc;
  }, 0);
  // const totalDISC_AMT = filteredData.reduce(
  //   (acc, item) => acc + parseFloat(item.DISC_AMT.replace(/,/g, "")),
  //   0
  // );
  const totalDISC_AMT = filteredData.reduce((acc, item) => {
    if (
      item.DISC_AMT !== "-" &&
      item.DISC_AMT !== "" &&
      item.ITEM_DESC == "Sub Total"
    ) {
      return acc + parseFloat(item.DISC_AMT.replace(/,/g, ""));
    }
    return acc;
  }, 0);
  // const totalSTAX_AMOUNT = filteredData.reduce(
  //   (acc, item) => acc + parseFloat(item.STAX_AMOUNT.replace(/,/g, "")),
  //   0
  // );
  const totalSTAX_AMOUNT = filteredData.reduce((acc, item) => {
    if (
      item.STAX_AMOUNT !== "-" &&
      item.STAX_AMOUNT !== "" &&
      item.ITEM_DESC == "Sub Total"
    ) {
      return acc + parseFloat(item.STAX_AMOUNT.replace(/,/g, ""));
    }
    return acc;
  }, 0);
  // const totalsub_total = filteredData.reduce(
  //   (acc, item) => acc + parseFloat(item.sub_total.replace(/,/g, "")),
  //   0
  // );
  const totalsub_total = filteredData.reduce((acc, item) => {
    if (
      item.sub_total !== "-" &&
      item.sub_total !== "" &&
      item.ITEM_DESC == "Sub Total"
    ) {
      return acc + parseFloat(item.sub_total.replace(/,/g, ""));
    }
    return acc;
  }, 0);
  const totalsurch = filteredData.reduce((acc, item) => {
    if (
      item.dstrb_surch !== "-" &&
      item.dstrb_surch !== "" &&
      item.ITEM_DESC == "Sub Total"
    ) {
      return acc + parseFloat(item.dstrb_surch.replace(/,/g, ""));
    }
    return acc;
  }, 0);
  // acc + parseFloat(item.dstrb_surch.replace(/,/g, ""))
  // const totalnet_Total = filteredData.reduce(
  //   (acc, item) => acc + parseFloat(item.net_Total.replace(/,/g, "")),
  //   0
  // );
  const totalnet_Total = filteredData.reduce((acc, item) => {
    if (
      item.net_Total !== "-" &&
      item.net_Total !== "" &&
      item.ITEM_DESC == "Sub Total"
    ) {
      return acc + parseFloat(item.net_Total.replace(/,/g, ""));
    }
    return acc;
  }, 0);
  const columns = [
    {
      dataField: "INVOICE_DATE",
      text: "Invoice Date",
      formatter: (cell, row, rowIndex, columnIndex) => {
        // console.log("row :>> ", row);

        if (
          row?.row_num > 0 &&
          row?.master_invoice_id ===
            filteredData[row.row_num - 1]?.master_invoice_id &&
          row?.ITEM_DESC !== "Sub Total"
        ) {
          return ""; // Hide value if same as previous, except for 'Sub Total' row
        }
        return cell; // Otherwise, display the original cell value
      },
      footerStyle: {
        textAlign: "center",
      },
      footer: "Total",
    },
    {
      dataField: "DOC_NO",
      text: "Doc #",
      formatter: (cell, row, rowIndex, columnIndex) => {
        if (
          row?.row_num > 0 &&
          row?.master_invoice_id ===
            filteredData[row.row_num - 1]?.master_invoice_id &&
          row?.ITEM_DESC !== "Sub Total"
        ) {
          return "";
        }
        return cell;
      },
      footer: "-",
    },
    isCompanyNameVisible && {
      dataField: "COMPANY_NAME",
      text: "Customer",
      formatter: (cell, row, rowIndex, columnIndex) => {
        if (
          row?.row_num > 0 &&
          row?.master_invoice_id ===
            filteredData[row.row_num - 1]?.master_invoice_id &&
          row?.ITEM_DESC !== "Sub Total"
        ) {
          return "";
        } else if (row.ITEM_DESC == "Sub Total") {
          return cell;
        } else {
          return cell;
        }
      },
      footer: "-",

      footerStyle: {
        textAlign: "center",
      },
    },
    {
      dataField: "order_type_desc",
      text: "Order Type",
      formatter: (cell, row, rowIndex, columnIndex) => {
        if (
          row?.row_num > 0 &&
          row?.master_invoice_id ===
            filteredData[row.row_num - 1]?.master_invoice_id &&
          row?.ITEM_DESC !== "Sub Total"
        ) {
          return "";
        } else if (row.ITEM_DESC == "Sub Total") {
          return cell;
        } else {
          return cell;
        }
      },
      footer: "-",

      footerStyle: {
        textAlign: "center",
      },
    },
    {
      dataField: "ITEM_CODE",
      text: "Code",
      sort: true,
      footer: "-",
      style: (cell, row, rowIndex, colIndex) => {
        return {
          textAlign: "center",
          fontWeight: row?.ITEM_DESC === "Sub Total" ? "bold" : "normal",
        };
      },
      footer: "-",

      footerStyle: {
        textAlign: "center",
      },
      headerStyle: () => {
        // Dynamically change width based on isCompanyNameVisible
        return {
          width: isCompanyNameVisible ? "" : "15%",
          textAlign: "center", // Optional: Keep consistent with style
        };
      },
    },
    {
      dataField: "ITEM_DESC",
      text: "Item",
      sort: true,
      footer: "-",
      style: (cell, row, rowIndex, colIndex) => {
        return {
          textAlign: "center",
          fontWeight: row?.ITEM_DESC === "Sub Total" ? "bold" : "normal",
        };
      },
      footer: "-",

      footerStyle: {
        textAlign: "center",
      },
      headerStyle: () => {
        // Dynamically change width based on isCompanyNameVisible
        return {
          width: isCompanyNameVisible ? "" : "15%",
          textAlign: "center", // Optional: Keep consistent with style
        };
      },
    },
    {
      dataField: "qty",
      text: "Qty",
      sort: true,
      footer: () => (totalqty ? new Intl.NumberFormat().format(totalqty) : 0),
      formatter: due_Formators,

      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
    {
      dataField: "rate",
      text: "Rate",
      sort: true,
      footer: "-",
      formatter: due_Formators,

      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "center",
      },
    },
    {
      dataField: "AMOUNT_EXC",
      text: "Total",
      sort: true,
      footer: () => new Intl.NumberFormat().format(totalAMOUNT_EXC),
      formatter: due_Formators,

      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
    {
      dataField: "DISC_AMT",
      text: "Discount",
      sort: true,
      footer: () => new Intl.NumberFormat().format(totalDISC_AMT),
      formatter: due_Formators,

      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
    {
      dataField: "STAX_AMOUNT",
      text: "Sale Tax",
      sort: true,
      footer: () => new Intl.NumberFormat().format(totalSTAX_AMOUNT),
      formatter: due_Formators,

      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
    {
      dataField: "sub_total",
      text: "Sub Total",
      sort: true,
      footer: () => new Intl.NumberFormat().format(totalsub_total),
      formatter: due_Formators,

      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
    {
      dataField: "dstrb_surch",
      text: "Surcharge",
      sort: true,
      footer: () => new Intl.NumberFormat().format(totalsurch),
      formatter: due_Formators,

      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
    {
      dataField: "net_Total",
      text: "Net Total",
      sort: true,
      // footer: () => new Intl.NumberFormat().format(totalnet_Total),
      footer: () => (totalnet_Total ? due_Formators(totalnet_Total) : 0),
      formatter: due_Formators,

      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
        isPrintVisible && {
      dataField: "actions",
      text: "Print",
      formatter: (cell, row) => {
        // Only show for the first row of each invoice or Sub Total row
        const shouldShow =
          row?.ITEM_DESC === "Sub Total" ||
          row?.row_num === 0 ||
          (row?.row_num > 0 &&
            row?.master_invoice_id !==
              filteredData[row.row_num - 1]?.master_invoice_id);

        if (!shouldShow || row?.ITEM_DESC === "Sub Total") {
          return "";
        }

        return (
          <Button
            color="primary"
            size="sm"
            onClick={() => handleBillWisePrint(row)}
            title="Print this invoice"
          >
            <i className="fa fa-print" aria-hidden="true" />
          </Button>
        );
      },
      headerStyle: { width: "80px", textAlign: "center" },
      style: { textAlign: "center" },
      footer: "-",
    },
  ].filter(Boolean);
  const columnsDollar = [
    {
      dataField: "INVOICE_DATE",
      text: "Invoice Date",
      formatter: (cell, row, rowIndex, columnIndex) => {
        // console.log("row :>> ", row);

        if (
          row?.row_num > 0 &&
          row?.master_invoice_id ===
            filteredData[row.row_num - 1]?.master_invoice_id &&
          row?.ITEM_DESC !== "Sub Total"
        ) {
          return ""; // Hide value if same as previous, except for 'Sub Total' row
        }
        return cell; // Otherwise, display the original cell value
      },
      footerStyle: {
        textAlign: "center",
      },
      footer: "Total",
    },
    {
      dataField: "DOC_NO",
      text: "Doc #",
      formatter: (cell, row, rowIndex, columnIndex) => {
        if (
          row?.row_num > 0 &&
          row?.master_invoice_id ===
            filteredData[row.row_num - 1]?.master_invoice_id &&
          row?.ITEM_DESC !== "Sub Total"
        ) {
          return "";
        }
        return cell;
      },
      footer: "-",
    },
    isCompanyNameVisible && {
      dataField: "COMPANY_NAME",
      text: "Customer",
      formatter: (cell, row, rowIndex, columnIndex) => {
        if (
          row?.row_num > 0 &&
          row?.master_invoice_id ===
            filteredData[row.row_num - 1]?.master_invoice_id &&
          row?.ITEM_DESC !== "Sub Total"
        ) {
          return "";
        } else if (row.ITEM_DESC == "Sub Total") {
          return cell;
        } else {
          return cell;
        }
      },
      footer: "-",

      footerStyle: {
        textAlign: "center",
      },
    },
    {
      dataField: "order_type_desc",
      text: "Order Type",
      formatter: (cell, row, rowIndex, columnIndex) => {
        if (
          row?.row_num > 0 &&
          row?.master_invoice_id ===
            filteredData[row.row_num - 1]?.master_invoice_id &&
          row?.ITEM_DESC !== "Sub Total"
        ) {
          return "";
        } else if (row.ITEM_DESC == "Sub Total") {
          return cell;
        } else {
          return cell;
        }
      },
      footer: "-",

      footerStyle: {
        textAlign: "center",
      },
    },
    {
      dataField: "ITEM_DESC",
      text: "Item",
      sort: true,
      footer: "-",
      style: (cell, row, rowIndex, colIndex) => {
        return {
          textAlign: "center",
          fontWeight: row?.ITEM_DESC === "Sub Total" ? "bold" : "normal",
        };
      },
      footer: "-",

      footerStyle: {
        textAlign: "center",
      },
      headerStyle: () => {
        // Dynamically change width based on isCompanyNameVisible
        return {
          width: isCompanyNameVisible ? "" : "15%",
          textAlign: "center", // Optional: Keep consistent with style
        };
      },
    },
    {
      dataField: "qty",
      text: "Qty",
      sort: true,
      footer: () => (totalqty ? new Intl.NumberFormat().format(totalqty) : 0),
      formatter: due_Formators,

      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
    {
      dataField: "rate",
      text: "Rate",
      sort: true,
      footer: "-",
      formatter: due_Formators,

      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "center",
      },
    },
    {
      dataField: "AMOUNT_EXC",
      text: "Total",
      sort: true,
      footer: () => new Intl.NumberFormat().format(totalAMOUNT_EXC),
      formatter: due_Formators,

      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
    {
      dataField: "DISC_AMT",
      text: "Discount",
      sort: true,
      footer: () => new Intl.NumberFormat().format(totalDISC_AMT),
      formatter: due_Formators,

      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
    {
      dataField: "STAX_AMOUNT",
      text: "Sale Tax",
      sort: true,
      footer: () => new Intl.NumberFormat().format(totalSTAX_AMOUNT),
      formatter: due_Formators,

      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
    {
      dataField: "sub_total",
      text: "Sub Total",
      sort: true,
      footer: () => new Intl.NumberFormat().format(totalsub_total),
      formatter: due_Formators,

      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
    {
      dataField: "dstrb_surch",
      text: "Surcharge",
      sort: true,
      footer: () => new Intl.NumberFormat().format(totalsurch),
      formatter: due_Formators,

      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
    {
      dataField: "net_Total",
      text: "Net Total",
      sort: true,
      footer: () => (totalnet_Total ? due_Formators(totalnet_Total) : 0),
      formatter: due_Formators,

      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
    {
      dataField: "time",
      text: "In Time",
      sort: true,
      footer: "-",

      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
        isPrintVisible && {
      dataField: "actions",
      text: "Print",
      formatter: (cell, row) => {
        // Only show for the first row of each invoice or Sub Total row
        const shouldShow =
          row?.ITEM_DESC === "Sub Total" ||
          row?.row_num === 0 ||
          (row?.row_num > 0 &&
            row?.master_invoice_id !==
              filteredData[row.row_num - 1]?.master_invoice_id);

        if (!shouldShow || row?.ITEM_DESC === "Sub Total") {
          return "";
        }

        return (
          <Button
            color="primary"
            size="sm"
            onClick={() => handleBillWisePrint(row)}
            title="Print this invoice"
          >
            <i className="fa fa-print" aria-hidden="true" />
          </Button>
        );
      },
      headerStyle: { width: "80px", textAlign: "center" },
      style: { textAlign: "center" },
      footer: "-",
    },
  ].filter(Boolean);

  const columnsEggSpectation = [
    {
      dataField: "INVOICE_DATE",
      text: "Invoice Date",
      formatter: (cell, row, rowIndex, columnIndex) => {
        // console.log("row :>> ", row);

        if (
          row?.row_num > 0 &&
          row?.master_invoice_id ===
            filteredData[row.row_num - 1]?.master_invoice_id &&
          row?.ITEM_DESC !== "Sub Total"
        ) {
          return ""; // Hide value if same as previous, except for 'Sub Total' row
        }
        return cell; // Otherwise, display the original cell value
      },
      footerStyle: {
        textAlign: "center",
      },
      footer: "Total",
    },
    {
      dataField: "DOC_NO",
      text: "Doc #",
      formatter: (cell, row, rowIndex, columnIndex) => {
        if (
          row?.row_num > 0 &&
          row?.master_invoice_id ===
            filteredData[row.row_num - 1]?.master_invoice_id &&
          row?.ITEM_DESC !== "Sub Total"
        ) {
          return "";
        }
        return cell;
      },
      footer: "-",
    },
    isCompanyNameVisible && {
      dataField: "COMPANY_NAME",
      text: "Customer",
      formatter: (cell, row, rowIndex, columnIndex) => {
        if (
          row?.row_num > 0 &&
          row?.master_invoice_id ===
            filteredData[row.row_num - 1]?.master_invoice_id &&
          row?.ITEM_DESC !== "Sub Total"
        ) {
          return "";
        } else if (row.ITEM_DESC == "Sub Total") {
          return cell;
        } else {
          return cell;
        }
      },
      footer: "-",

      footerStyle: {
        textAlign: "center",
      },
    },
    {
      dataField: "order_type_desc",
      text: "Order Type",
      formatter: (cell, row, rowIndex, columnIndex) => {
        if (
          row?.row_num > 0 &&
          row?.master_invoice_id ===
            filteredData[row.row_num - 1]?.master_invoice_id &&
          row?.ITEM_DESC !== "Sub Total"
        ) {
          return "";
        } else if (row.ITEM_DESC == "Sub Total") {
          return cell;
        } else {
          return cell;
        }
      },
      footer: "-",

      footerStyle: {
        textAlign: "center",
      },
    },
    {
      dataField: "ITEM_DESC",
      text: "Item",
      sort: true,
      footer: "-",
      style: (cell, row, rowIndex, colIndex) => {
        return {
          textAlign: "center",
          fontWeight: row?.ITEM_DESC === "Sub Total" ? "bold" : "normal",
        };
      },
      footer: "-",

      footerStyle: {
        textAlign: "center",
      },
      headerStyle: () => {
        // Dynamically change width based on isCompanyNameVisible
        return {
          width: isCompanyNameVisible ? "" : "15%",
          textAlign: "center", // Optional: Keep consistent with style
        };
      },
    },
    {
      dataField: "qty",
      text: "Qty",
      sort: true,
      footer: () => (totalqty ? new Intl.NumberFormat().format(totalqty) : 0),
      formatter: due_Formators,

      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
    {
      dataField: "rate",
      text: "Rate",
      sort: true,
      footer: "-",
      formatter: due_Formators,

      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "center",
      },
    },
    {
      dataField: "AMOUNT_EXC",
      text: "Total",
      sort: true,
      footer: () => new Intl.NumberFormat().format(totalAMOUNT_EXC),
      formatter: due_Formators,

      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
    {
      dataField: "DISC_AMT",
      text: "Discount",
      sort: true,
      footer: () => new Intl.NumberFormat().format(totalDISC_AMT),
      formatter: due_Formators,

      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
    {
      dataField: "STAX_AMOUNT",
      text: "Sale Tax",
      sort: true,
      footer: () => new Intl.NumberFormat().format(totalSTAX_AMOUNT),
      formatter: due_Formators,

      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
    {
      dataField: "sub_total",
      text: "Sub Total",
      sort: true,
      footer: () => new Intl.NumberFormat().format(totalsub_total),
      formatter: due_Formators,

      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
    {
      dataField: "dstrb_surch",
      text: "Surcharge",
      sort: true,
      footer: () => new Intl.NumberFormat().format(totalsurch),
      formatter: due_Formators,

      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
    {
      dataField: "net_Total",
      text: "Net Total",
      sort: true,
      footer: () => (totalnet_Total ? due_Formators(totalnet_Total) : 0),
      formatter: due_Formators,

      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
    {
      dataField: "waiter",
      text: "Waiter",
      sort: true,
      footer: "-",

      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
        isPrintVisible && {
      dataField: "actions",
      text: "Print",
      formatter: (cell, row) => {
        // Only show for the first row of each invoice or Sub Total row
        const shouldShow =
          row?.ITEM_DESC === "Sub Total" ||
          row?.row_num === 0 ||
          (row?.row_num > 0 &&
            row?.master_invoice_id !==
              filteredData[row.row_num - 1]?.master_invoice_id);

        if (!shouldShow || row?.ITEM_DESC === "Sub Total") {
          return "";
        }

        return (
          <Button
            color="primary"
            size="sm"
            onClick={() => handleBillWisePrint(row)}
            title="Print this invoice"
          >
            <i className="fa fa-print" aria-hidden="true" />
          </Button>
        );
      },
      headerStyle: { width: "80px", textAlign: "center" },
      style: { textAlign: "center" },
      footer: "-",
    },
  ].filter(Boolean);

  const defaultSorted = [
    {
      dataField: "name",
      order: "desc",
    },
  ];
  // Function to handle bill-wise print
  const handleBillWisePrint = (invoiceData) => {
    // Get all items for this specific invoice
    const invoiceItems = filteredData.filter(
      (item) =>
        item.master_invoice_id === invoiceData.master_invoice_id &&
        item.ITEM_DESC !== "Sub Total"
    );

    // Calculate totals for this invoice
    const totals = {
      qty: invoiceItems.reduce(
        (sum, item) =>
          sum + parseFloat(item.qty.toString().replace(/,/g, "") || 0),
        0
      ),
      AMOUNT_EXC: invoiceItems.reduce(
        (sum, item) =>
          sum + parseFloat(item.AMOUNT_EXC.toString().replace(/,/g, "") || 0),
        0
      ),
      DISC_AMT: invoiceItems.reduce(
        (sum, item) =>
          sum + parseFloat(item.DISC_AMT.toString().replace(/,/g, "") || 0),
        0
      ),
      STAX_AMOUNT: invoiceItems.reduce(
        (sum, item) =>
          sum + parseFloat(item.STAX_AMOUNT.toString().replace(/,/g, "") || 0),
        0
      ),
      sub_total: invoiceItems.reduce(
        (sum, item) =>
          sum + parseFloat(item.sub_total.toString().replace(/,/g, "") || 0),
        0
      ),
      dstrb_surch: invoiceItems.reduce(
        (sum, item) =>
          sum + parseFloat(item.dstrb_surch.toString().replace(/,/g, "") || 0),
        0
      ),
      net_Total: invoiceItems.reduce(
        (sum, item) =>
          sum + parseFloat(item.net_Total.toString().replace(/,/g, "") || 0),
        0
      ),
    };

    // Format totals
    const formattedTotals = {
      qty: due_Formators(totals.qty),
      AMOUNT_EXC: due_Formators(totals.AMOUNT_EXC),
      DISC_AMT: due_Formators(totals.DISC_AMT),
      STAX_AMOUNT: due_Formators(totals.STAX_AMOUNT),
      sub_total: due_Formators(totals.sub_total),
      dstrb_surch: due_Formators(totals.dstrb_surch),
      net_Total: due_Formators(totals.net_Total),
    };

    // Prepare bill data
    const billData = {
      invoiceDate: invoiceData.INVOICE_DATE,
      docNo: invoiceData.DOC_NO,
      customerName: invoiceData.COMPANY_NAME,
      orderType: invoiceData.order_type_desc,
      items: invoiceItems.map((item) => ({
        ITEM_DESC: item.ITEM_DESC,
        qty: due_Formators(item.qty),
        rate: due_Formators(item.rate),
        AMOUNT_EXC: due_Formators(item.AMOUNT_EXC),
        DISC_AMT: due_Formators(item.DISC_AMT),
        STAX_AMOUNT: due_Formators(item.STAX_AMOUNT),
        sub_total: due_Formators(item.sub_total),
        dstrb_surch: due_Formators(item.dstrb_surch),
        net_Total: due_Formators(item.net_Total),
      })),
      totals: formattedTotals,
    };

    // Navigate to BillWisePrint component
    props.history.push({
      pathname: "/BillWisePrint",
      state: { billData },
    });
  };

  // Formatter for DOC_NO column with print link
  const docNoFormatter = (cell, row, rowIndex, columnIndex) => {
    // Only show for the first row of each invoice or Sub Total row
    const shouldShow =
      row?.ITEM_DESC === "Sub Total" ||
      row?.row_num === 0 ||
      (row?.row_num > 0 &&
        row?.master_invoice_id !==
          filteredData[row.row_num - 1]?.master_invoice_id);

    if (!shouldShow) {
      return "";
    }

    // For Sub Total rows, just show the doc number
    if (row?.ITEM_DESC === "Sub Total") {
      return cell;
    }

    // For regular rows, show clickable link
    return (
      <span
        style={{
          color: "#007bff",
          cursor: "pointer",
          textDecoration: "underline",
        }}
        onClick={() => handleBillWisePrint(row)}
        title="Click to print this invoice"
      >
        {cell}
      </span>
    );
  };
  return (
    <>
      <div className="position-relative">
        <div
          className={`container-fluid bg-white ${
            loadingResponce ? "blur-background" : ""
          }`}
        >
          <ReportsCriteria
            reportName="Sale Details Report"
            lovs={["item", "ordertype", "branch", "saleChannel"]}
            // callBack={() => {}}
            invoiceType={1}
            companyId={companyId}
            token={token}
            username={username}
            handleFind={(p) => handleFind(p)}
            tableData={table.OverViewDataTable}
            isMulti={true}
            callBack={(p) => handleDynamicColapse(p)}
            sendSearchedData={(p) => sendSearchedData(p)}
          />

          <div className="row float-right pr-4">
            <Button
              color="secondary"
              className="button-22"
              onClick={() => graph()}
              id="invoiceButton"
            >
              Graph
            </Button>
            <Decimal
              showAsInteger={showAsInteger}
              onToggle={setShowAsInteger}
            />
            <Button
              color="success"
              className="button-22 "
              onClick={() => {
                dollarTrue
                  ? funPrintView(
                      table.printDataDollar,
                      listOfColLablesDollar,
                      listOfColKeyDollar,
                      data
                    )
                  : eggSpectaionTrue
                  ? funPrintView(
                      table.printDataEggSpectation,
                      listOfColLablesEggSpectation,
                      listOfColKeyEggSpectation,
                      data
                    )
                  : funPrintView(
                      table.printData,
                      listOfColLables,
                      listOfColKey,
                      data
                    );
              }}
              id="invoiceButton"
            >
              Print
            </Button>

            {table?.listOfData?.length > 0 ? (
              <ExportToExcel
                Data={
                  dollarTrue
                    ? table.listOfDataDollar
                    : eggSpectaionTrue
                    ? table.listOfDataEggSpectation
                    : table.listOfData
                }
                listOfColKey={
                  dollarTrue
                    ? listOfColKeyDollar
                    : eggSpectaionTrue
                    ? listOfColKeyEggSpectation
                    : listOfColKey
                }
                DynamicReports={true}
                ReportName="Sale_Detail_Report"
                criteriaString={data.criteriaString}
              />
            ) : null}
          </div>
          <div translate="no" className="">
            <Button
              color={isCompanyNameVisible ? "secondary" : "warning"}
              className="button-22"
              onClick={toggleCompanyName}
            >
              {isCompanyNameVisible ? (
                <>
                  <i className="fa fa-eye-slash" aria-hidden="true" /> Customer
                </>
              ) : (
                <>
                  <i className="fa fa-eye" aria-hidden="true" /> Customer
                </>
              )}
            </Button>
            {/* <Button
              color={isPrintVisible ? "secondary" : "warning"}
              className="button-22 ml-2"
              onClick={() => setisPrintVisible(!isPrintVisible)}
            >
              {isPrintVisible ? (
                <>
                  <i className="fa fa-eye-slash" aria-hidden="true" /> Print
                </>
              ) : (
                <>
                  <i className="fa fa-eye" aria-hidden="true" /> Print
                </>
              )}
            </Button> */}
            <div className="sticky-table-wrapper">
              <div className="sticky-table-container">
                <PaginationProvider pagination={paginationFactory(options)}>
                  {({ paginationProps, paginationTableProps }) => (
                    <div>
                      {/* TOP Pagination Controls */}
                      <div className="d-flex justify-content-between align-items-center my-2">
                        <SizePerPageDropdownStandalone {...paginationProps} />
                        {/* <PaginationListStandalone {...paginationProps} /> */}
                      </div>

                      <BootstrapTable
                        // {...paginationTableProps}
                        key={`${showAsInteger}`}
                        keyField="id"
                        data={filteredData}
                        columns={
                          dollarTrue
                            ? columnsDollar
                            : eggSpectaionTrue
                            ? columnsEggSpectation
                            : columns
                        }
                        defaultSorted={defaultSorted}
                        headerClasses="rpr_header"
                        tableBodyClass="rpr_body"
                        containerClass="rpr_container"
                        rowClasses={rowClassNameFormat}
                        striped
                        condensed
                        hover
                        {...paginationTableProps}
                      />

                      {/* REMOVE this if you want pagination ONLY at the top */}
                      {/* <div className="d-flex justify-content-between align-items-center mt-2">
                     <SizePerPageDropdownStandalone {...paginationProps} />
                     <PaginationListStandalone {...paginationProps} />
                   </div> */}
                    </div>
                  )}
                </PaginationProvider>
              </div>
            </div>

            {/* <div>
              {table?.totalSumAll
                ? TableSumCustom(listOfSum, table.totalSumAll)
                : null}
            </div> */}
          </div>
        </div>
        {loadingResponce && (
          <div className="loader-overlay">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
